// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Container(props) {
  let __mobilePadding = props.mobilePadding;
  let mobilePadding = __mobilePadding !== undefined ? __mobilePadding : true;
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "w-full mx-auto md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]",
      mobilePadding ? "px-4" : "md:px-4",
      Stdlib_Option.getOr(props.className, "")
    ]),
    id: "container"
  });
}

let make = Container;

exports.make = make;
/* tailwind-merge Not a pure module */
